import React, { useEffect } from "react";
import { Row, Col, Button } from "react-bootstrap";

const TargetEditSection = (props) => {
	const isEditMode = props.isEditMode;
	const setReload = props.setReload;
	const setIsEditMode = props.setIsEditMode;

	const btnStyle = { width: "100px", float: "right" };
	const sectionStyle = { margin: "20px 0" };

	useEffect(() => {
		setIsEditMode(props.isEditMode);
		return () => {
			setIsEditMode(false);
		};
	}, [props.isEditMode]);

	return (
		<Row style={sectionStyle}>
			<Col md="9"></Col>

			<Col md="3">
				{!isEditMode ? (
					<Button style={btnStyle} onClick={() => setIsEditMode(true)}>
						Edit
					</Button>
				) : (
					<Button
						style={btnStyle}
						variant="secondary"
						onClick={() => {
							setIsEditMode(false);
							setReload(true);
						}}
					>
						Cancel
					</Button>
				)}
			</Col>
		</Row>
	);
};

export default TargetEditSection;
